// Number formatting utilities.

/**
 * Format a number using compact notation (e.g. 85000000000 -> "85B").
 * Uses the native Intl.NumberFormat API so no extra dependency is required.
 */
export function formatCompactNumber(value: number): string {
  return new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(value);
}
